import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatListModule } from '@angular/material/list';
import { MatSortModule } from '@angular/material/sort';
import { LicenseUserAvatarModule } from '@portal-core/license-users/components/license-user-avatar/license-user-avatar.module';
import { LicenseUsersSelectListModule } from '@portal-core/license-users/components/license-users-select-list/license-users-select-list.module';
import { LicenseUserForLicenseAsyncModule } from '@portal-core/license-users/pipes/license-user-for-license-async/license-user-for-license-async.module';
import { ProjectAvatarModule } from '@portal-core/projects/components/project-avatar/project-avatar.module';
import { ProjectsSelectListModule } from '@portal-core/projects/components/projects-select-list/projects-select-list.module';
import { ProjectAsyncModule } from '@portal-core/projects/pipes/project-async/project-async.module';
import { AutocompleteInputModule } from '@portal-core/ui/autocomplete/components/autocomplete-input/autocomplete-input.module';
import { GridHeaderFilterModule } from '@portal-core/ui/grid/components/grid-header-filter/grid-header-filter.module';
import { GridHeaderFilterFormModule } from '@portal-core/ui/grid/directives/grid-header-filter-form/grid-header-filter-form.module';
import { GridHeaderFilterMenuModule } from '@portal-core/ui/grid/directives/grid-header-filter-menu/grid-header-filter-menu.module';
import { McColorModule } from '@portal-core/ui/themes/directives/mc-color.module';
import { GridSelectFilterComponent } from './grid-select-filter.component';

@NgModule({
  imports: [
    McColorModule,
    AutocompleteInputModule,
    CommonModule,
    FormsModule,
    GridHeaderFilterFormModule,
    GridHeaderFilterMenuModule,
    GridHeaderFilterModule,
    LicenseUserAvatarModule,
    LicenseUserForLicenseAsyncModule,
    MatButtonModule,
    MatFormFieldModule,
    MatListModule,
    MatSortModule,
    ProjectAvatarModule,
    LicenseUsersSelectListModule,
    ProjectsSelectListModule,
    ReactiveFormsModule,
    ProjectAsyncModule
  ],
  declarations: [GridSelectFilterComponent],
  exports: [GridSelectFilterComponent]
})
export class GridSelectFilterModule { }
